import React, { useState, useEffect } from "react";
import BannerComponent from "./HomeBanner";
import MembersComponent from "./Members";
import EventComponent from "./Events";
import NewsComponent from "./News";
import CommunityComponents from "./Community";
import LifeMemberComponents from "./LifeMember";
import Styles from '../Styles/Common.module.css';
import ResetPassword from "../Common/Login/ResetPassword";
import { useLocation } from 'react-router-dom';

const HomeRoute = () => {
    const [resetToken, setResetToken] = useState(null);
    const [resetPopup, setResetPopup] = useState(false);

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token'); 
    const resetpopup = searchParams.get('resetpopup');

    useEffect(() => {
        if (token && resetpopup === "true") {
            setResetToken(token);
            setResetPopup(true);
        }
    }, [token, resetpopup]);
    const popupCloseHandler=()=>{
        setResetPopup(false);
    }
    return (
        <div className={Styles.HomeRoute}>
            <BannerComponent />
            <MembersComponent />
            <EventComponent />
            <NewsComponent />
            <CommunityComponents />
            <LifeMemberComponents />
            
            {resetPopup && <ResetPassword onClose={popupCloseHandler} TokenRest={resetToken} />}
        </div>
    );
}

export default HomeRoute;
